(function () {
  'use strict';
  const dialog = document.getElementById('OuroLabDialog');
  const template = document.getElementById('OuroLabTemplate');
  if (!dialog || !template) return;
  const status = dialog.querySelector('[role=status]');
  let frame, ready = false, pending, opener, timeout, leaving = false, queuedTrigger;
  const historyToken = 'ouro-' + Date.now() + '-' + Math.random().toString(36).slice(2);
  const ownsEntry = () => window.history.state && window.history.state.ouroLab === historyToken;
  function dispatch() {
    if (ready && pending && dialog.open) {
      // Opaque sandbox origin: target is the exact iframe window; no personal data is sent.
      frame.contentWindow.postMessage(pending, '*'); pending = null;
    }
  }
  function close() {
    if (!dialog.open || leaving) return;
    if (ownsEntry()) { leaving = true; window.history.back(); }
    else dialog.close();
  }
  function open(trigger) {
    if (leaving) { queuedTrigger = trigger; return; }
    opener = trigger;
    const title = dialog.querySelector('#OuroLabTitle');
    if (title) title.textContent = ['library', 'search', 'product'].includes(trigger.dataset.ouroLab) ? 'Productos OURO' : 'Encuentra tu producto ideal';
    pending = {type:'ouro-lab-open',action:trigger.dataset.ouroLab,productId:trigger.dataset.product,family:trigger.dataset.family,query:trigger.dataset.query};
    if (!dialog.open) {
      // One same-document entry. Back closes the overlay, not the storefront.
      // Answers and search terms are never written into history or the URL.
      try { window.history.pushState(Object.assign({}, window.history.state, {ouroLab:historyToken}), ''); } catch (e) { /* dialog still works without History API */ }
      dialog.showModal();
    }
    document.documentElement.classList.add('ouro-lab-open');
    if (!frame) {
      frame = template.content.querySelector('iframe').cloneNode(true);
      dialog.querySelector('.ouro-lab-frame').appendChild(frame);
      timeout = setTimeout(function () {
        if (!ready) status.textContent = 'No se pudo iniciar el laboratorio. Cierra esta ventana, recarga la página e inténtalo de nuevo.';
      }, 15000);
    }
    dispatch();
  }
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-ouro-lab]');
    if (!trigger || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); open(trigger);
  });
  window.addEventListener('popstate', function () {
    leaving = false;
    if (ownsEntry() && frame) {
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('ouro-lab-open');
      if (ready) frame.contentWindow.postMessage({type:'ouro-lab-resume'}, '*');
      dispatch();
    } else if (dialog.open) dialog.close();
    if (queuedTrigger) { const trigger = queuedTrigger; queuedTrigger = null; setTimeout(() => open(trigger), 0); }
  });
  dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
  dialog.querySelector('[data-ouro-lab-close]').addEventListener('click', close);
  dialog.addEventListener('close', function () {
    if (frame) frame.contentWindow.postMessage({type:'ouro-lab-suspend'}, '*');
    document.documentElement.classList.remove('ouro-lab-open');
    const menuToggle = document.querySelector('.menu-toggle');
    if (opener && opener.closest('#SiteNav') && menuToggle && window.getComputedStyle(menuToggle).display !== 'none') menuToggle.focus();
    else if (opener && opener.isConnected) opener.focus();
    if (ownsEntry() && !leaving) { leaving = true; window.history.back(); }
  });
  window.addEventListener('message', function (event) {
    if (!frame || event.source !== frame.contentWindow || !event.data) return;
    if (event.data.type === 'ouro-lab-ready') {
      ready = true; clearTimeout(timeout); status.hidden = true; dispatch();
    } else if (event.data.type === 'ouro-lab-close') close();
  });
})();
